import { useState } from "react";
import { useOptionApi } from "@/hooks/apiHooks/useOptionApi";
import { Button, Label } from "@common/index";
import { Input } from "@common/Form/Input";
import type { OptionResponse } from "@models/option";
import { ComponentColor } from "@common/types";

export const Option = () => {
    const { createOption, getOptions } = useOptionApi();
    const [name, setName] = useState("");
    const [options, setOptions] = useState<OptionResponse[]>([]);

    const handleCreate = async () => {
        if (!name.trim()) {
            return;
        }

        await createOption({ name: name.trim() });
        setName("");
    };

    const handleGetOptions = async () => {
        const response = await getOptions();
        setOptions(response);
    };

    return (
        <div className="p-6 bg-white rounded-lg shadow-md max-w-4xl">
            <h2 className="text-xl font-bold mb-4">Options</h2>

            <div className="space-y-4 mb-6">
                <div>
                    <Label>Option Name *</Label>
                    <Input
                        name="name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Enter option name"
                    />
                </div>

                <div className="flex gap-2">
                    <Button onClick={handleGetOptions} color={ComponentColor.Secondary}>
                        Get All Options
                    </Button>
                    <Button onClick={handleCreate} color={ComponentColor.Primary}>
                        Create Option
                    </Button>
                </div>
            </div>

            {options.length > 0 && (
                <div className="mt-6 border-t pt-4">
                    <h3 className="text-lg font-semibold mb-3">Options:</h3>
                    <div className="bg-gray-50 p-4 rounded text-left">
                        {options.map((option) => (
                            <div key={option.id} className="py-1">
                                <span className="font-medium">ID: {option.id}</span> -{" "}
                                {option.name}{" "}
                                <span className="text-sm text-gray-500">
                                    ({option.values.length} value{option.values.length !== 1 ? "s" : ""},{" "}
                                    {option.isActive ? "active" : "inactive"})
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
